// Generate the pinterest object needed to identify product variant in their
// analytics
export default function getPinterestVariantOptions({ price, id, material, size }) {
  const lineItem = {
    product_name: window.rambleMaps.productKey,
    product_variant_id: id,
    product_price: price,
    product_id: window.rambleMaps.productId,
    product_category: "Wall Art"
  };

  // if we have a size, we have a map with skus made of material and size
  if (size) {
    lineItem.product_variant = `${material}-${size[0]}-${size[1]}`;
  // otherwise we have a gift card with a price
  } else {
    lineItem.product_variant = price;
  }
  return {
    line_items: [lineItem]
  }
}
